import { useEffect, useState } from "react";
import { X, Trophy, Gift } from "lucide-react";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

const T = {
  es: { title: "GANADORES SEMANALES", sub: "¡Felicidades a nuestros jugadores premiados!", empty: "Aún no hay ganadores. ¡Jugá y podrías ser el próximo!", from: (s) => `cortesía de ${s}` },
  en: { title: "WEEKLY WINNERS", sub: "Congrats to our prize-winning players!", empty: "No winners yet. Play and you could be next!", from: (s) => `courtesy of ${s}` },
};

// Public list of sponsor-gift winners (no promo codes shown).
export default function WeeklyWinners({ onClose }) {
  const { lang } = useLang();
  const t = T[lang] || T.es;
  const [items, setItems] = useState(null);

  useEffect(() => { api.publicWinners().then((r) => setItems(r.data || [])).catch(() => setItems([])); }, []);

  return (
    <div className="fixed inset-0 z-[80] bg-black/85 overflow-y-auto overscroll-contain flex items-start justify-center p-4" data-testid="weekly-winners-modal" onClick={onClose}>
      <div className="pixel-card bg-[#141414] w-full max-w-md p-6 relative max-h-full overflow-y-auto my-auto" onClick={(e) => e.stopPropagation()}>
        <button data-testid="weekly-winners-close" onClick={onClose} className="absolute top-3 right-3 text-white/60 hover:text-white"><X size={22} /></button>
        <h2 className="font-pixel text-base text-[#FFEB3B] pixel-stroke flex items-center gap-2"><Trophy size={18} /> {t.title}</h2>
        <p className="font-vt text-lg text-white/65 mt-2 mb-4">{t.sub}</p>

        {items === null ? (
          <p className="font-vt text-lg text-white/50">…</p>
        ) : items.length === 0 ? (
          <p data-testid="weekly-winners-empty" className="font-vt text-lg text-white/60 text-center py-6">{t.empty}</p>
        ) : (
          <div className="space-y-2">
            {items.map((w, i) => (
              <div key={i} data-testid={`weekly-winner-${i}`} className="flex items-center gap-3 p-3 rounded-xl border-2 border-[#FFB300]/30 bg-[#FFB300]/5">
                <div className="shrink-0 w-9 h-9 rounded-full bg-[#FFB300] text-black font-pixel text-[11px] flex items-center justify-center">{i + 1}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-pixel text-[11px] text-[#FFEB3B] truncate">{w.username}</div>
                  <div className="font-vt text-base text-white/85 leading-tight flex items-center gap-1.5">
                    <Gift size={14} className="text-[#FFB300] shrink-0" /> {w.gift}{w.sponsor ? ` · ${t.from(w.sponsor)}` : ""}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
